export default __webpack_public_path__ + "static/media/Berlingltstd-roman.c031e0fb.woff2";